export const SELF = 'self';
export const ADMIN = 'admin';
export const SCHEDULED_PROCESS = 'scheduled process';

export default Object.freeze({
    SELF,
    ADMIN,
    SCHEDULED_PROCESS
});